<template>
  <div>
    <Scholarship v-if="ScholarshipView" @ScholarshipFunc="ScholarshipFunc" />
    <Income v-if="IncomeView" @IncomeFunc="IncomeFunc" @IncomeFuncBack="IncomeFuncBack" />
    <Advisor
      v-if="AdvisorView"
      @AdvisorFunc="AdvisorFunc"
      @AdvisorFuncBack="AdvisorFuncBack"
    />
    <PreviewMode
      v-if="PreviewView"
      @ViewScholarship="ViewScholarship"
      @EditScholarship="EditScholarship"
      @ViewIncome="ViewIncome"
      @EditIncome="EditIncome"
      @ViewAdvisor="ViewAdvisor"
      @EditAdvisor="EditAdvisor"
    />
  </div>
</template>

<script>
import Advisor from "@/components/advisor.vue";
import Income from "@/components/income.vue";
import Scholarship from "@/components/scholarship.vue";
import PreviewMode from "@/components/previewMode.vue";

export default {
  name: "MembershipApplicationCpfHome",
  components: {
    Advisor,
    Income,
    Scholarship,
    PreviewMode,
  },
  data() {
    return {
      ScholarshipView: true,
      IncomeView: false,
      AdvisorView: false,
      PreviewView: false,
      RandomID: null,
    };
  },
  async mounted() {},
  methods: {
    ScholarshipFunc() {
      this.ScholarshipView = !this.ScholarshipView;
      this.IncomeView = !this.IncomeView;
      window.scrollTo(0, 0);
    },
    IncomeFunc() {
      this.IncomeView = !this.IncomeView;
      this.AdvisorView = !this.AdvisorView;
      window.scrollTo(0, 0);
    },
    AdvisorFunc() {
      this.AdvisorView = !this.AdvisorView;
      this.PreviewView = !this.PreviewView;
      window.scrollTo(0, 0);
    },
    IncomeFuncBack() {
      this.ScholarshipView = !this.ScholarshipView;
      this.IncomeView = !this.IncomeView;
      sessionStorage.setItem("ScholarshipEdit", true);
      window.scrollTo(0, 0);
    },
    AdvisorFuncBack() {
      this.IncomeView = !this.IncomeView;
      this.AdvisorView = !this.AdvisorView;
      sessionStorage.setItem("IncomeEdit", true);
      window.scrollTo(0, 0);
    },
    ViewScholarship() {
      sessionStorage.setItem("ViewScholarship", true);
    },
    EditScholarship() {
      sessionStorage.setItem("EditScholarship", true);
    },
    ViewIncome() {
      sessionStorage.setItem("ViewIncome", true);
    },
    EditIncome() {
      sessionStorage.setItem("EditIncome", true);
    },
    ViewAdvisor() {
      sessionStorage.setItem("ViewAdvisor", true);
    },
    EditAdvisor() {
      sessionStorage.setItem("EditAdvisor", true);
    },
  },
};
</script>

<style lang="scss" scoped></style>
